import React from 'react'
import _ from 'lodash'
import popup from '~/views/Popup/popup'
import connect from '~/tools/connect'
import userStore from '~/redux/user/store'
import { fetchModels } from '~/redux/models/helpers';

class VideoWall extends React.Component {
  constructor(props) {
    super(props)

    this.pushButtonEvent = this.pushButtonEvent.bind(this)
  }

  async componentDidMount() {
    if (!window.dataLayer)
      return

    window.dataLayer.push({
      'event': 'soft_wall_shown',
      'video_title': this.props.videoGist.title,
      'video_id': this.props.videoGist.id
    })

    this.setState({ model: await fetchModels() })
  }

  pushButtonEvent(source) {
    if (!window.dataLayer)
      return

    window.dataLayer.push({
      'event': 'subscribe_cta_click',
      'source': source
    })
  }

  render() {
    const background = {
      background: `url(${this.props.videoGist.videoImageUrl}) no-repeat`,
      backgroundSize: 'cover',
    }
    const { content: video } = this.props
    if (this.state.model === 'TVOD' && this.props.isEpisode) {
      video.openPurchaseScreen()
    }

    if (window.SERVER_SIDE_RENDERING)
      return <div className="subscription-prompt" style={ background }></div>

    const subscriptionText = _.get(window.settings, ('subscription_flow_content.subscription_button_text'))
    const loginText = _.get(window.settings, ('subscription_flow_content.login_button_text'))

    return(
      <div className="subscription-prompt" style={ background }>
        <div className="overlay">
          <p>
            {_.get(window.settings, ('subscription_flow_content.overlay_message'))}
          </p>
          <div className="button-container">
            { window.sessionStorage.getItem('openUpdatecard')
              ? <a href="/user/account" className="cta button"> Activate Now </a>
              : <a
                  href="/viewplans"
                  className="cta button"
                  onClick={ () => this.pushButtonEvent('video_wall') }
                >
                  { (subscriptionText !== undefined) ? subscriptionText: 'Start Your Free Trial' }
                </a>
            }

            { !this.state.user && (
              <button className="cta login-btn" onClick={ evt => popup.login() }>
              { (loginText !== undefined) ? loginText: 'Login' }
              </button>
            ) }
          </div>
        </div>
      </div>
    )
  }
}

connect(VideoWall, state => ({ user: state.user }), userStore)
export default VideoWall;
